(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["butter-lush-colour-slider"] && !Shopify.designMode) return;
  try {
    
  class ButterColourSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.butter-slider__track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot-index]')];
      this.previousButton = this.querySelector('.butter-slider__arrow--previous');
      this.nextButton = this.querySelector('.butter-slider__arrow--next');
      this.activeIndex = 0;

      this.desktopQuery = window.matchMedia('(min-width: 750px)');

      if (this.desktopQuery.matches) {
        this.slides.forEach((slide, index) => {
          slide.addEventListener('click', () => this.activate(index));
          slide.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.activate(index);
            }
          });
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('role', 'button');
        });
        this.activate(0);
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) this.activate(this.slides.indexOf(visible.target));
        },
        { root: this.track, threshold: [0.55, 0.7, 0.85] }
      );

      if (!this.desktopQuery.matches) {
        this.slides.forEach((slide) => this.observer.observe(slide));
      }
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dotIndex))));
      this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) this.goTo(index);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    activate(index) {
      if (index < 0) return;
      this.activeIndex = index;
      this.style.setProperty('--section-background', this.slides[index].dataset.background);
      this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    goTo(index) {
      const targetIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      if (this.desktopQuery.matches) {
        this.activate(targetIndex);
        return;
      }
      const target = this.slides[targetIndex];
      if (!target) return;
      const left = target.offsetLeft - (this.track.clientWidth - target.offsetWidth) / 2;
      this.track.scrollTo({ left, behavior: 'smooth' });
    }
  }

  if (!customElements.get('butter-colour-slider')) {
    customElements.define('butter-colour-slider', ButterColourSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
